var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhatsNewActive = function SvgWhatsNewActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "m16.892 14.814.901.9a.698.698 0 0 1-.496 1.193h-10.6c-.623 0-.93-.753-.49-1.193l.902-.9v-4.186a4.88 4.88 0 0 1 3.843-4.765v-.816C10.952 4.467 11.42 4 12 4c.58 0 1.048.467 1.048 1.047v.816a4.88 4.88 0 0 1 3.844 4.765v4.186Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M14 18a2 2 0 0 1-4 0h4Z"
  })));
};
export default SvgWhatsNewActive;